import { useState, useEffect, useRef } from "react";
import {
  getTenants,
  getAssignToPropertyList,
  createTenants,
  getTenantsById,
  updateTenantsById,
  getMasterIndustryList,
  getOccupationByIndustryId,
  toggleTenantStatusById,
  BedAssignmentForTenant,
  getPgPropertyForId,
  getBedPickerForBedAssignment,
  assignBedToTenant,
  unassignBedToTenant,
  getFoodPlanForTenant,
  allotedFoodPlanForTenant,
  assignFoodPlanToTenant,
} from "../../../services/propertyOwner/propertyOwnerServices";
import { getMasterPincode } from "../../../services/admin/adminServices";
import toast from "../../../utils/toast";

const INITIAL_FORM = {
  fullName: "",
  fatherName: "",
  mobile: "",
  whatsApp: "",
  email: "",
  permanentAddress: "",
  pincode: "",
  area: "",
  district: "",
  state: "",
  occupation: "",
  industryId: "",
  occupationId: "",
  company: "",
  tenantType: "Unit",
  propertyId: "",
  startDate: "",
  endDate: "",
  additionalMobiles: [],
  coMembers: [],
  emergencyContacts: [],
};

export default function OwnerTenants() {
  const [isTenantData, setTenantData] = useState(null);
  const [listLoading, setListLoading] = useState(true);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [filters, setFilters] = useState({
    kycStatusId: "",
    pageNumber: 1,
    pageSize: 10,
  });
  const [searchInput, setSearchInput] = useState("");

  const [isModalOpenAddTenant, setIsModalOpenAddTenant] = useState(false);
  const [isModalOpenEditTenant, setIsModalOpenEditTenant] = useState(false);
  const [addTenantForm, setAddTenantForm] = useState(INITIAL_FORM);
  const [editTenantForm, setEditTenantForm] = useState({});
  const [selectedTenant, setSelectedTenant] = useState(null);
  const [addTenantErrors, setAddTenantErrors] = useState({});
  const [editTenantErrors, setEditTenantErrors] = useState({});
  const [addTenantLoading, setAddTenantLoading] = useState(false);
  const [editTenantLoading, setEditTenantLoading] = useState(false);
  const [industries, setIndustries] = useState([]);
  const [occupations, setOccupations] = useState([]);
  const [editOccupations, setEditOccupations] = useState([]);
  const [isAssignPropertyData, setAssignPropertyData] = useState([]);

  // Bed Assignment states
  const [bedAssignOpen, setBedAssignOpen] = useState(false);
  const [bedAssignTenant, setBedAssignTenant] = useState(null);
  const [bedAssignData, setBedAssignData] = useState(null);
  const [bedAssignLoading, setBedAssignLoading] = useState(false);
  const [pgProperties, setPgProperties] = useState([]);
  const [selectedPgPropertyId, setSelectedPgPropertyId] = useState("");
  const [selectedSharingTypeId, setSelectedSharingTypeId] = useState(null);
  const [roomBeds, setRoomBeds] = useState([]);
  const [roomBedsLoading, setRoomBedsLoading] = useState(false);
  const [selectedBedIds, setSelectedBedIds] = useState([]);
  const [selectedRoomId, setSelectedRoomId] = useState(null);
  const [saveAssignLoading, setSaveAssignLoading] = useState(false);
  const [unassignLoading, setUnassignLoading] = useState(false);

  const [foodAssignOpen, setFoodAssignOpen] = useState(false);
  const [foodAssignTenant, setFoodAssignTenant] = useState(null);
  const [foodPlans, setFoodPlans] = useState([]);
  const [foodPlansLoading, setFoodPlansLoading] = useState(false);
  const [selectedFoodPlanId, setSelectedFoodPlanId] = useState(null);
  const [saveFoodLoading, setSaveFoodLoading] = useState(false);

  useEffect(() => {
    fetchTenants();
  }, [filters]);

  useEffect(() => {
    if (isModalOpenAddTenant || isModalOpenEditTenant) {
      fetchIndustries();
      fetchAssignToProperty();
    }
  }, [isModalOpenAddTenant, isModalOpenEditTenant]);

  useEffect(() => {
    if (!searchInput && !filters.search) return;
    const timer = setTimeout(() => {
      setFilters((prev) => ({ ...prev, search: searchInput, pageNumber: 1 }));
    }, 600);
    return () => clearTimeout(timer);
  }, [searchInput]);

  useEffect(() => {
    if (addTenantForm.industryId)
      fetchOccupations(addTenantForm.industryId, "add");
    else setOccupations([]);
  }, [addTenantForm.industryId]);

  useEffect(() => {
    if (editTenantForm.industryId)
      fetchOccupations(editTenantForm.industryId, "edit");
    else setEditOccupations([]);
  }, [editTenantForm.industryId]);

  const fetchTenants = async () => {
    setListLoading(true);
    try {
      const params = Object.fromEntries(
        Object.entries(filters).filter(([_, v]) => v !== ""),
      );
      const res = await getTenants(params);
      if (res.statusCode === 1) {
        setTenantData(res.data);
        setTotalCount(res.data.paging.totalCount);
        setTotalPages(res.data.paging.totalPages);
      }
    } catch (err) {
      console.log(err.response?.data?.message || "Failed to fetch tenants");
    } finally {
      setListLoading(false);
    }
  };

  const fetchIndustries = async () => {
    try {
      const res = await getMasterIndustryList();
      setIndustries(res.filter((i) => i.isActive));
    } catch (err) {
      console.log("Failed to fetch industries");
    }
  };

  const fetchAssignToProperty = async () => {
    try {
      const res = await getAssignToPropertyList();
      setAssignPropertyData(res.data);
    } catch (err) {
      console.log("Failed to fetch industries");
    }
  };

  const fetchOccupations = async (industryId, mode) => {
    try {
      const res = await getOccupationByIndustryId(industryId);
      const active = res.filter((o) => o.isActive);
      if (mode === "add") setOccupations(active);
      else setEditOccupations(active);
    } catch (err) {
      console.log("Failed to fetch occupations");
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value, pageNumber: 1 }));
  };

  const handlePageChange = (page) => {
    setFilters((prev) => ({ ...prev, pageNumber: page }));
  };

  const getKycBadge = (kycStatus) => {
    if (kycStatus === "approved")
      return { bg: "#EAF3DE", color: "#27500A", label: "✓ KYC Approved" };
    if (kycStatus === "pending")
      return { bg: "#FEF3C7", color: "#92400E", label: "⏳ Pending" };
    if (kycStatus === "rejected")
      return { bg: "#FCEBEB", color: "#A32D2D", label: "✕ Rejected" };
    return { bg: "#F3F4F6", color: "#6B7280", label: "○ Not Applied" };
  };

  // ── Add handlers ──
  const openAddTenantModal = () => {
    setAddTenantForm(INITIAL_FORM);
    setAddTenantErrors({});
    setIsModalOpenAddTenant(true);
  };

  const closeAddTenantModal = () => {
    setIsModalOpenAddTenant(false);
    setAddTenantForm(INITIAL_FORM);
    setAddTenantErrors({});
  };

  const handleAddTenantChange = (e) => {
    const { name, value } = e.target;

    if (name === "occupationId") {
      const selectedOcc = occupations.find(
        (o) => o.occupationId === Number(value),
      );
      setAddTenantForm((prev) => ({
        ...prev,
        [name]: value,
        occupation: selectedOcc?.occupationName || "",
      }));
      setAddTenantErrors((prev) => ({ ...prev, [name]: "" }));
      return;
    }

    setAddTenantForm((prev) => ({ ...prev, [name]: value }));
    setAddTenantErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleAddPincodeChange = async (e) => {
    handleAddTenantChange(e);
    if (e.target.value.length === 6) {
      try {
        const res = await getMasterPincode(e.target.value);
        if (res.statusCode === 1) {
          setAddTenantForm((prev) => ({
            ...prev,
            area: res.data.areaName || prev.area,
            district: res.data.district,
            state: res.data.stateName,
          }));
        }
      } catch (err) {}
    }
  };

  const validateAddTenant = () => {
    const e = {};
    if (!addTenantForm.fullName) e.fullName = "Full name is required.";
    if (!addTenantForm.mobile) e.mobile = "Mobile is required.";
    setAddTenantErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleCreateTenant = async () => {
    if (!validateAddTenant()) return;
    setAddTenantLoading(true);
    try {
      const payload = {
        ...addTenantForm,
        industryId: Number(addTenantForm.industryId) || 0,
        occupationId: Number(addTenantForm.occupationId) || 0,
        propertyId: Number(addTenantForm.propertyId) || 0,
        startDate: addTenantForm.startDate
          ? new Date(addTenantForm.startDate).toISOString()
          : null,
        endDate: addTenantForm.endDate
          ? new Date(addTenantForm.endDate).toISOString()
          : null,
        coMembers: addTenantForm.coMembers.map((m) => ({
          ...m,
          age: Number(m.age) || 0,
        })),
      };
      const res = await createTenants(payload);
      if (res.statusCode === 1) {
        toast.success(res.message);
        closeAddTenantModal();
        fetchTenants();
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Something went wrong.");
    } finally {
      setAddTenantLoading(false);
    }
  };

  // ── Edit handlers ──
  const openEditTenantModal = async (tenantId) => {
    try {
      const res = await getTenantsById(tenantId);
      if (res.statusCode === 1) {
        const d = res.data;
        setSelectedTenant(d);
        setEditTenantForm({
          fullName: d.fullName || "",
          fatherName: d.fatherName || "",
          mobile: d.mobile || "",
          whatsApp: d.whatsApp || "",
          email: d.email || "",
          permanentAddress: d.permanentAddress || "",
          pincode: d.pincode || "",
          area: d.area || "",
          district: d.district || "",
          state: d.state || "",
          occupation: d.occupation || "",
          industryId: d.industryId || "",
          occupationId: d.occupationId || "",
          company: d.company || "",
          tenantType: d.tenantType || "Bed",
          propertyId: d.propertyId || "",
          startDate: d.startDate ? d.startDate.split("T")[0] : "",
          endDate: d.endDate ? d.endDate.split("T")[0] : "",
          additionalMobiles: d.additionalMobiles || [],
          coMembers: d.coMembers || [],
          emergencyContacts: d.emergencyContacts || [],
        });
        setEditTenantErrors({});
        setIsModalOpenEditTenant(true);
      }
    } catch (err) {
      toast.error("Failed to load tenant details.");
    }
  };

  const closeEditTenantModal = () => {
    setIsModalOpenEditTenant(false);
    setSelectedTenant(null);
    setEditTenantForm({});
    setEditTenantErrors({});
  };

  const handleEditTenantChange = (e) => {
    const { name, value } = e.target;

    if (name === "occupationId") {
      const selectedOcc = editOccupations.find(
        (o) => o.occupationId === Number(value),
      );
      setEditTenantForm((prev) => ({
        ...prev,
        [name]: value,
        occupation: selectedOcc?.occupationName || "",
      }));
      setEditTenantErrors((prev) => ({ ...prev, [name]: "" }));
      return;
    }

    setEditTenantForm((prev) => ({ ...prev, [name]: value }));
    setEditTenantErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleEditPincodeChange = async (e) => {
    handleEditTenantChange(e);
    if (e.target.value.length === 6) {
      try {
        const res = await getMasterPincode(e.target.value);
        if (res.statusCode === 1) {
          setEditTenantForm((prev) => ({
            ...prev,
            area: res.data.areaName || prev.area,
            district: res.data.district,
            state: res.data.stateName,
          }));
        }
      } catch (err) {}
    }
  };

  const validateEditTenant = () => {
    const e = {};
    if (!editTenantForm.fullName) e.fullName = "Full name is required.";
    if (!editTenantForm.mobile) e.mobile = "Mobile is required.";
    setEditTenantErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleUpdateTenant = async () => {
    if (!validateEditTenant()) return;
    setEditTenantLoading(true);
    try {
      const payload = {
        ...editTenantForm,
        industryId: Number(editTenantForm.industryId) || 0,
        occupationId: Number(editTenantForm.occupationId) || 0,
        propertyId: Number(editTenantForm.propertyId) || 0,
        startDate: editTenantForm.startDate
          ? new Date(editTenantForm.startDate).toISOString()
          : null,
        endDate: editTenantForm.endDate
          ? new Date(editTenantForm.endDate).toISOString()
          : null,
        coMembers: editTenantForm.coMembers.map((m) => ({
          ...m,
          age: Number(m.age) || 0,
        })),
      };
      const res = await updateTenantsById(selectedTenant.tenantId, payload);
      if (res.statusCode === 1) {
        toast.success(res.message);
        closeEditTenantModal();
        fetchTenants();
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Something went wrong.");
    } finally {
      setEditTenantLoading(false);
    }
  };

  const handleToggleTenantStatus = async (id, status) => {
    try {
      const res = await toggleTenantStatusById(id, { isActive: !status });
      if (res.statusCode === 1) {
        toast.success(res.message);
        fetchTenants();
      }
    } catch (err) {
      toast.error("Failed to toggle tenant status.");
    }
  };

  const openBedAssignTenantModal = async (id) => {
    setBedAssignLoading(true);
    setBedAssignOpen(true);
    setSelectedSharingTypeId(null);
    setSelectedPgPropertyId("");
    setRoomBeds([]);
    setSelectedBedIds([]);
    setSelectedRoomId(null);
    try {
      const [assignRes, propRes] = await Promise.all([
        BedAssignmentForTenant(id),
        getPgPropertyForId(),
      ]);
      if (assignRes.statusCode === 1) {
        setBedAssignData(assignRes.data);
        setBedAssignTenant(assignRes.data.assignment);
        // pre-select sharing type from existing assignment
        if (assignRes.data.assignment?.bedId) {
          setSelectedSharingTypeId(null); // let user pick
        }
      }
      if (propRes.statusCode === 1) setPgProperties(propRes.data || []);
    } catch (err) {
      toast.error("Failed to load bed assignment.");
      setBedAssignOpen(false);
    } finally {
      setBedAssignLoading(false);
    }
  };

  const handlePgPropertyChange = async (pgPropertyId) => {
    setSelectedPgPropertyId(pgPropertyId);
    setRoomBeds([]);
    setSelectedBedIds([]);
    setSelectedRoomId(null);
    if (!pgPropertyId) return;
    setRoomBedsLoading(true);
    try {
      const res = await getBedPickerForBedAssignment(pgPropertyId);
      if (res.statusCode === 1) setRoomBeds(res.data || []);
    } catch {
      console.log("Failed to load beds");
    } finally {
      setRoomBedsLoading(false);
    }
  };

  const maxBedsAllowed = () => {
    if (!selectedSharingTypeId || !bedAssignData) return 1;
    const st = bedAssignData.sharingTypes.find(
      (s) => s.sharingTypeId === selectedSharingTypeId,
    );
    return st?.maxPersons || 1;
  };

  const handleBedToggle = (bedId, roomId) => {
    const max = maxBedsAllowed();
    setSelectedBedIds((prev) => {
      if (prev.includes(bedId)) return prev.filter((b) => b !== bedId);
      if (prev.length >= max) return prev; // can't select more than allowed
      return [...prev, bedId];
    });
    setSelectedRoomId(roomId);
  };

  const handleSaveAssignment = async () => {
    if (!selectedSharingTypeId) {
      toast.error("Please select bed type.");
      return;
    }
    if (!selectedPgPropertyId) {
      toast.error("Please select a PG property.");
      return;
    }
    if (selectedBedIds.length === 0) {
      toast.error("Please select at least one bed.");
      return;
    }
    setSaveAssignLoading(true);
    try {
      const res = await assignBedToTenant(bedAssignTenant.tenantId, {
        pgPropertyId: Number(selectedPgPropertyId),
        pgRoomId: selectedRoomId,
        bedIds: selectedBedIds,
      });
      if (res.statusCode === 1) {
        toast.success(res.message);
        setBedAssignOpen(false);
        fetchTenants();
      } else {
        toast.error(res.message);
      }
    } catch {
      toast.error("Failed to save assignment.");
    } finally {
      setSaveAssignLoading(false);
    }
  };

  const handleUnassignBed = async () => {
    setUnassignLoading(true);
    try {
      const res = await unassignBedToTenant(bedAssignTenant.tenantId);
      if (res.statusCode === 1) {
        toast.success(res.message);
        setBedAssignOpen(false);
        fetchTenants();
      } else {
        toast.error(res.message);
      }
    } catch {
      toast.error("Failed to unassign bed.");
    } finally {
      setUnassignLoading(false);
    }
  };

  // const openFoodAssignTenantModal = async (
  //   tenantId,
  //   propertyId,
  //   fullName,
  //   mobile,
  // ) => {
  //   setFoodAssignTenant({ tenantId, propertyId, fullName, mobile });
  //   setSelectedFoodPlanId(null);
  //   setFoodPlans([]);
  //   setFoodAssignOpen(true);
  //   setFoodPlansLoading(true);
  //   try {
  //     const res = await getFoodPlanForTenant(propertyId);
  //     if (res.statusCode === 1) setFoodPlans(res.data || []);
  //   } catch {
  //     console.log("Failed to load food plans");
  //   } finally {
  //     setFoodPlansLoading(false);
  //   }
  // };

  const openFoodAssignTenantModal = async (
    tenantId,
    pgPropertyId,
    fullName,
    mobile,
  ) => {
    setFoodAssignTenant({ tenantId, pgPropertyId, fullName, mobile });
    setSelectedFoodPlanId(null);
    setFoodPlans([]);
    setFoodAssignOpen(true);
    setFoodPlansLoading(true);
    try {
      const [plansRes, allotedRes] = await Promise.all([
        getFoodPlanForTenant(pgPropertyId),
        allotedFoodPlanForTenant(tenantId),
      ]);
      if (plansRes.statusCode === 1) setFoodPlans(plansRes.data || []);
      if (allotedRes.statusCode === 1 && allotedRes.data?.foodPlanId) {
        setSelectedFoodPlanId(allotedRes.data.foodPlanId);
      }
    } catch {
      console.log("Failed to load food plans");
    } finally {
      setFoodPlansLoading(false);
    }
  };

  const handleSaveFoodPlan = async () => {
    setSaveFoodLoading(true);
    try {
      const res = await assignFoodPlanToTenant(foodAssignTenant.tenantId, {
        foodPlanId: selectedFoodPlanId ?? 0,
      });
      if (res.statusCode === 1) {
        toast.success(res.message);
        setFoodAssignOpen(false);
      } else {
        toast.error(res.message);
      }
    } catch {
      toast.error("Failed to save food plan.");
    } finally {
      setSaveFoodLoading(false);
    }
  };
  return (
    <>
      <div className="main">
        <div className="topbar">
          <div>
            <div className="page-title">Tenants</div>
            <div className="page-sub">Manage tenants</div>
          </div>
          <div className="topbar-right">
            <button className="btn btn-primary" onClick={openAddTenantModal}>
              + Add Tenant
            </button>
          </div>
        </div>

        <div className="content">
          <div className="stat-grid mb16">
            <div className="stat-card">
              <div className="stat-icon">👤</div>
              <div className="stat-label">Total Tenants</div>
              <div className="stat-value">
                {isTenantData?.totalTenants ?? 0}
              </div>
              <div className="stat-delta delta-up">Registered</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">✅</div>
              <div className="stat-label">Occupying</div>
              <div className="stat-value">
                {isTenantData?.occupyingCount ?? 0}
              </div>
              <div className="stat-delta delta-up">Active</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">🛡</div>
              <div className="stat-label">KYC Approved</div>
              <div className="stat-value">
                {isTenantData?.kycApprovedCount ?? 0}
              </div>
              <div className="stat-delta delta-up">Verified</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">📋</div>
              <div className="stat-label">Unassigned</div>
              <div className="stat-value">
                {isTenantData?.unitTenantsCount ?? 0}
              </div>
              <div className="stat-delta delta-dn">No room</div>
            </div>
          </div>

          <div className="card">
            <div className="flex-between mb12">
              <div className="card-title" style={{ margin: 0 }}>
                All Tenants
              </div>
              <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <input
                  type="text"
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                  placeholder="Search name, mobile…"
                  style={{ padding: "5px 10px", fontSize: 12, width: 170 }}
                />
                <select
                  name="kycStatusId"
                  value={filters.kycStatusId}
                  onChange={handleFilterChange}
                  style={{
                    fontSize: 12,
                    padding: "5px 8px",
                    border: "0.5px solid var(--border-mid)",
                    borderRadius: 6,
                  }}
                >
                  <option value="">All KYC Statuses</option>
                  <option value="3">✓ Approved</option>
                  <option value="2">⏳ Pending</option>
                  <option value="4">✕ Rejected</option>
                  <option value="1">○ Not Applied</option>
                </select>
                {(searchInput || filters.kycStatusId) && (
                  <button
                    className="btn btn-lg"
                    style={{ background: "#185fa5", color: "#fff" }}
                    onClick={() => {
                      setSearchInput("");
                      setFilters({
                        kycStatusId: "",
                        pageNumber: 1,
                        pageSize: 10,
                      });
                    }}
                  >
                    Reset
                  </button>
                )}
              </div>
            </div>

            <div style={{ overflowX: "auto" }}>
              <table style={{ minWidth: 900, width: "100%" }}>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Tenant</th>
                    <th>Email</th>
                    <th>Assigned Unit</th>
                    <th>Assigned Food</th>
                    <th>Occupation</th>
                    <th>Start Date</th>
                    <th>Last Payment</th>
                    <th>KYC</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {listLoading ? (
                    Array.from({ length: 5 }).map((_, i) => (
                      <tr key={i}>
                        {Array.from({ length: 10 }).map((_, j) => (
                          <td key={j}>
                            <div
                              style={{
                                height: 14,
                                borderRadius: 6,
                                background:
                                  "linear-gradient(90deg, var(--bg-secondary) 25%, var(--border-light) 50%, var(--bg-secondary) 75%)",
                                backgroundSize: "200% 100%",
                                animation: "shimmer 1.4s infinite",
                                width:
                                  j === 1 ? "80%" : j === 9 ? "60%" : "70%",
                              }}
                            />
                          </td>
                        ))}
                      </tr>
                    ))
                  ) : isTenantData?.tenants?.length === 0 ? (
                    <tr>
                      <td
                        colSpan={10}
                        style={{
                          textAlign: "center",
                          color: "var(--text-tertiary)",
                          padding: 24,
                        }}
                      >
                        No tenants found.
                      </td>
                    </tr>
                  ) : (
                    isTenantData?.tenants?.map((t, index) => {
                      const kyc = getKycBadge(t.kycStatus);
                      return (
                        <tr key={t.tenantId}>
                          <td className="sn-col">
                            {(filters.pageNumber - 1) *
                              Number(filters.pageSize) +
                              index +
                              1}
                          </td>
                          <td style={{ whiteSpace: "nowrap" }}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 6,
                              }}
                            >
                              <span style={{ fontWeight: 600 }}>
                                {t.fullName}
                              </span>
                              <span
                                style={{
                                  fontSize: 9,
                                  fontWeight: 700,
                                  padding: "2px 7px",
                                  borderRadius: 99,
                                  background:
                                    t.tenantType === "Unit"
                                      ? "var(--blue-light, #EFF6FF)"
                                      : "var(--bg-secondary)",
                                  color:
                                    t.tenantType === "Unit"
                                      ? "var(--blue, #599fe4)"
                                      : "var(--green, #d1f0c3)",
                                  border: `0.5px solid ${t.tenantType === "Unit" ? "var(--light-blue, #90abc5)" : "var(--light-green, #90c59c)"}`,
                                }}
                              >
                                {t.tenantType === "Unit" ? "🏠 UNIT" : "🛏 BED"}
                              </span>
                            </div>
                            <div
                              style={{
                                fontSize: 11,
                                color: "var(--text-secondary)",
                              }}
                            >
                              📱 {t.mobile}
                            </div>
                            {t.coMemberCount > 0 && (
                              <div
                                style={{
                                  fontSize: 10,
                                  color: "var(--teal)",
                                  marginTop: 2,
                                }}
                              >
                                +{t.coMemberCount} co-tenant
                              </div>
                            )}
                            {t.emergencyContactCount > 0 && (
                              <div
                                style={{
                                  fontSize: 10,
                                  color: "var(--amber)",
                                  marginTop: 1,
                                }}
                              >
                                🚨 {t.emergencyContactCount} emergency contact
                              </div>
                            )}
                          </td>
                          <td style={{ fontSize: 11 }}>{t.email || "—"}</td>
                          <td style={{ whiteSpace: "nowrap" }}>
                            {t.propertyUnitNo || t.propertyHouseNo ? (
                              <>
                                <div style={{ fontSize: 12, fontWeight: 500 }}>
                                  {t.propertyUnitNo || t.propertyHouseNo}
                                </div>
                                <div
                                  style={{
                                    fontSize: 10,
                                    color: "var(--text-tertiary)",
                                  }}
                                >
                                  {t.societyName}
                                </div>
                              </>
                            ) : (
                              "—"
                            )}
                          </td>

                          <td>
                            <span
                              style={{
                                background: t.foodPlanLabel
                                  ? "var(--green-light, #f0fdf4)"
                                  : "var(--bg-secondary)",
                                color: t.foodPlanLabel
                                  ? "var(--green, #16a34a)"
                                  : "var(--text-secondary)",
                                border: `0.5px solid ${
                                  t.foodPlanLabel
                                    ? "var(--light-green, #90c59c)"
                                    : "var(--border, #e5e7eb)"
                                }`,
                                borderRadius: 99,
                                padding: "3px 10px",
                                fontSize: 10,
                                fontWeight: 700,
                                whiteSpace: "nowrap",
                              }}
                            >
                              🍽 {t.foodPlanLabel ?? "No Plan"}
                            </span>
                          </td>
                          <td style={{ fontSize: 11 }}>
                            {t.occupationName || "—"}
                          </td>
                          <td
                            style={{
                              fontSize: 11,
                              color: "var(--text-secondary)",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {t.startDate
                              ? new Date(t.startDate).toLocaleDateString(
                                  "en-IN",
                                  {
                                    day: "2-digit",
                                    month: "short",
                                    year: "numeric",
                                  },
                                )
                              : "—"}
                          </td>
                          <td
                            style={{
                              fontSize: 11,
                              color: "var(--text-secondary)",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {t.lastPaymentDate
                              ? new Date(t.lastPaymentDate).toLocaleDateString(
                                  "en-IN",
                                  {
                                    day: "2-digit",
                                    month: "short",
                                    year: "numeric",
                                  },
                                )
                              : "—"}
                          </td>
                          <td>
                            <span
                              style={{
                                background: kyc.bg,
                                color: kyc.color,
                                borderRadius: 99,
                                padding: "3px 10px",
                                fontSize: 10,
                                fontWeight: 700,
                                cursor: "pointer",
                                whiteSpace: "nowrap",
                                border: `0.5px solid ${kyc.color}33`,
                              }}
                            >
                              {kyc.label}
                            </span>
                          </td>
                          <td>
                            <span
                              className={`badge ${t.isActive ? "badge-active" : "badge-inactive"}`}
                            >
                              {t.isActive ? "Active" : "Inactive"}
                            </span>
                          </td>
                          <td>
                            <div className="td-actions">
                              <span
                                className="action-icon"
                                title="Edit"
                                onClick={() => openEditTenantModal(t.tenantId)}
                              >
                                <span className="tip">Edit</span>✎
                              </span>
                              {t.tenantType === "Unit" && (
                                <span
                                  className="action-icon"
                                  title="Change Property"
                                  onClick={() =>
                                    openEditTenantModal(t.tenantId)
                                  }
                                >
                                  <span className="tip">Change Property</span>🏠
                                </span>
                              )}

                              {t.tenantType === "Bed" && (
                                <span
                                  className="action-icon"
                                  title="Assign Bed"
                                  onClick={() =>
                                    openBedAssignTenantModal(t.tenantId)
                                  }
                                >
                                  <span className="tip">Assign Bed </span>🛏
                                </span>
                              )}

                              {t.tenantType === "Bed" && (
                                <span
                                  className="action-icon"
                                  title="Assign Food"
                                  onClick={() =>
                                    openFoodAssignTenantModal(
                                      t.tenantId,
                                      t.pgPropertyId,
                                      t.fullName,
                                      t.mobile,
                                    )
                                  }
                                >
                                  <span className="tip">Assign Food </span>🍽
                                </span>
                              )}

                              {t.isActive ? (
                                <span
                                  className="action-icon red"
                                  title="Deactivate"
                                  onClick={() =>
                                    handleToggleTenantStatus(
                                      t.tenantId,
                                      t.isActive,
                                    )
                                  }
                                >
                                  <span className="tip">Deactivate</span>⊗
                                </span>
                              ) : (
                                <span
                                  className="action-icon green"
                                  title="Activate"
                                  onClick={() =>
                                    handleToggleTenantStatus(
                                      t.tenantId,
                                      t.isActive,
                                    )
                                  }
                                >
                                  <span className="tip">Activate</span>✓
                                </span>
                              )}
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>

            <div
              style={{
                marginTop: 12,
                display: "flex",
                justifyContent: "space-between",
                fontSize: 12,
                color: "var(--text-secondary)",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <select
                  value={filters.pageSize}
                  onChange={(e) =>
                    setFilters((prev) => ({
                      ...prev,
                      pageSize: Number(e.target.value),
                      pageNumber: 1,
                    }))
                  }
                  style={{ fontSize: 12, padding: "4px 8px" }}
                >
                  <option value={10}>10 / page</option>
                  <option value={20}>20 / page</option>
                  <option value={50}>50 / page</option>
                </select>
                <span>
                  Showing <strong>{isTenantData?.tenants?.length ?? 0}</strong>{" "}
                  of <strong>{totalCount}</strong>
                </span>
              </div>
              <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
                <button
                  className="btn btn-xs"
                  disabled={filters.pageNumber === 1}
                  onClick={() => handlePageChange(filters.pageNumber - 1)}
                >
                  ‹ Prev
                </button>
                <span
                  style={{
                    padding: "2px 8px",
                    background: "var(--blue)",
                    color: "#fff",
                    borderRadius: 5,
                    fontSize: 11,
                  }}
                >
                  {filters.pageNumber}
                </span>
                <button
                  className="btn btn-xs"
                  disabled={filters.pageNumber === totalPages}
                  onClick={() => handlePageChange(filters.pageNumber + 1)}
                >
                  Next ›
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── Add Tenant Modal ── */}
      {isModalOpenAddTenant && (
        <div className="modal-overlay open">
          <div className="modal" style={{ width: 860, maxWidth: "98vw" }}>
            <div className="modal-header">
              <div className="modal-title">Add New Tenant</div>
              <button className="modal-close" onClick={closeAddTenantModal}>
                ✕
              </button>
            </div>
            <div className="modal-body">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                  marginBottom: 20,
                  padding: "12px 16px",
                  background: "var(--bg-secondary)",
                  borderRadius: "var(--radius-md)",
                }}
              >
                <span
                  style={{
                    fontSize: 13,
                    fontWeight: 600,
                    color: "var(--text-secondary)",
                    marginRight: 4,
                  }}
                >
                  Tenant Type:
                </span>
                {[
                  { value: "Unit", label: "Unit Tenant", icon: "🏠" },
                  { value: "Bed", label: "Bed/Seat Tenant", icon: "🛏" },
                ].map((opt) => (
                  <label
                    key={opt.value}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      padding: "8px 18px",
                      border: `1.5px solid ${addTenantForm.tenantType === opt.value ? "var(--blue)" : "var(--border-mid)"}`,
                      borderRadius: "var(--radius-md)",
                      cursor: "pointer",
                      background:
                        addTenantForm.tenantType === opt.value
                          ? "var(--blue-light)"
                          : "#fff",
                      fontWeight:
                        addTenantForm.tenantType === opt.value ? 700 : 400,
                    }}
                  >
                    <input
                      type="radio"
                      name="tenantType"
                      value={opt.value}
                      checked={addTenantForm.tenantType === opt.value}
                      onChange={handleAddTenantChange}
                      style={{ accentColor: "var(--blue)" }}
                    />
                    <span style={{ fontSize: 16 }}>{opt.icon}</span>
                    <span style={{ fontSize: 13 }}>{opt.label}</span>
                  </label>
                ))}
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: 20,
                  marginBottom: 16,
                }}
              >
                {/* LEFT */}

                <div>
                  {/* Tenant Type — top of modal */}

                  <div
                    style={{
                      fontSize: 11,
                      fontWeight: 700,
                      color: "var(--text-tertiary)",
                      textTransform: "uppercase",
                      letterSpacing: ".06em",
                      marginBottom: 12,
                    }}
                  >
                    Personal Details
                  </div>

                  <div className="form-group mb12">
                    <label>Full Name *</label>
                    <input
                      type="text"
                      name="fullName"
                      value={addTenantForm.fullName}
                      onChange={handleAddTenantChange}
                      placeholder="e.g. Priya Sharma"
                      style={
                        addTenantErrors.fullName
                          ? { borderColor: "#dc2626" }
                          : {}
                      }
                    />
                    {addTenantErrors.fullName && (
                      <span style={{ color: "#dc2626", fontSize: 11 }}>
                        {addTenantErrors.fullName}
                      </span>
                    )}
                  </div>

                  <div className="form-group mb12">
                    <label>Father's Name</label>
                    <input
                      type="text"
                      name="fatherName"
                      value={addTenantForm.fatherName}
                      onChange={handleAddTenantChange}
                      placeholder="e.g. Ramesh Sharma"
                    />
                  </div>

                  <div className="form-grid mb8">
                    <div className="form-group">
                      <label>Primary Mobile *</label>
                      <input
                        type="tel"
                        name="mobile"
                        value={addTenantForm.mobile}
                        onChange={handleAddTenantChange}
                        placeholder="10-digit number"
                        style={
                          addTenantErrors.mobile
                            ? { borderColor: "#dc2626" }
                            : {}
                        }
                      />
                      {addTenantErrors.mobile && (
                        <span style={{ color: "#dc2626", fontSize: 11 }}>
                          {addTenantErrors.mobile}
                        </span>
                      )}
                    </div>
                    <div className="form-group">
                      <label>
                        WhatsApp{" "}
                        <span
                          style={{
                            fontSize: 10,
                            color: "var(--text-tertiary)",
                            fontWeight: 400,
                          }}
                        >
                          (blank = same as mobile)
                        </span>
                      </label>
                      <input
                        type="tel"
                        name="whatsApp"
                        value={addTenantForm.whatsApp}
                        onChange={handleAddTenantChange}
                        placeholder="WhatsApp number"
                      />
                    </div>
                  </div>

                  {/* Additional Mobiles */}
                  <div style={{ marginBottom: 12 }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginBottom: 5,
                      }}
                    >
                      <label
                        style={{
                          fontSize: 12,
                          fontWeight: 600,
                          color: "var(--text-secondary)",
                        }}
                      >
                        Additional Mobiles
                      </label>
                      <button
                        type="button"
                        className="btn btn-xs"
                        onClick={() =>
                          setAddTenantForm((prev) => ({
                            ...prev,
                            additionalMobiles: [
                              ...prev.additionalMobiles,
                              { mobile: "", label: "Mobile" },
                            ],
                          }))
                        }
                      >
                        + Add Number
                      </button>
                    </div>
                    {addTenantForm.additionalMobiles.length === 0 ? (
                      <div
                        style={{ fontSize: 11, color: "var(--text-tertiary)" }}
                      >
                        None added
                      </div>
                    ) : (
                      addTenantForm.additionalMobiles.map((m, i) => (
                        <div
                          key={i}
                          style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr 28px",
                            gap: 8,
                            marginBottom: 6,
                          }}
                        >
                          <input
                            type="tel"
                            value={m.mobile}
                            onChange={(e) =>
                              setAddTenantForm((prev) => ({
                                ...prev,
                                additionalMobiles: prev.additionalMobiles.map(
                                  (x, idx) =>
                                    idx === i
                                      ? { ...x, mobile: e.target.value }
                                      : x,
                                ),
                              }))
                            }
                            placeholder="Mobile number"
                            style={{ fontSize: 12, padding: "6px 8px" }}
                          />
                          <select
                            value={m.label}
                            onChange={(e) =>
                              setAddTenantForm((prev) => ({
                                ...prev,
                                additionalMobiles: prev.additionalMobiles.map(
                                  (x, idx) =>
                                    idx === i
                                      ? { ...x, label: e.target.value }
                                      : x,
                                ),
                              }))
                            }
                            style={{ fontSize: 12, padding: "6px 8px" }}
                          >
                            <option value="Mobile">Mobile</option>
                            <option value="WhatsApp">WhatsApp</option>
                            <option value="Work">Work</option>
                            <option value="Other">Other</option>
                          </select>
                          <button
                            onClick={() =>
                              setAddTenantForm((prev) => ({
                                ...prev,
                                additionalMobiles:
                                  prev.additionalMobiles.filter(
                                    (_, idx) => idx !== i,
                                  ),
                              }))
                            }
                            style={{
                              width: 28,
                              height: 28,
                              border: "0.5px solid #F09595",
                              background: "var(--red-light)",
                              color: "var(--red)",
                              borderRadius: 5,
                              cursor: "pointer",
                              fontSize: 15,
                            }}
                          >
                            ×
                          </button>
                        </div>
                      ))
                    )}
                  </div>

                  <div className="form-group mb12">
                    <label>Email</label>
                    <input
                      type="email"
                      name="email"
                      value={addTenantForm.email}
                      onChange={handleAddTenantChange}
                      placeholder="tenant@email.com"
                    />
                  </div>

                  <div className="form-group mb12">
                    <label>Permanent Address</label>
                    <textarea
                      name="permanentAddress"
                      value={addTenantForm.permanentAddress}
                      onChange={handleAddTenantChange}
                      style={{ minHeight: 56 }}
                      placeholder="Full permanent address"
                    />
                  </div>

                  <div className="form-group mb12">
                    <label>Pincode</label>
                    <input
                      type="text"
                      name="pincode"
                      value={addTenantForm.pincode}
                      onChange={handleAddPincodeChange}
                      maxLength={6}
                      placeholder="6-digit pincode"
                    />
                  </div>

                  <div className="form-grid mb12">
                    <div className="form-group">
                      <label>Area / Locality</label>
                      <input
                        type="text"
                        name="area"
                        value={addTenantForm.area}
                        onChange={handleAddTenantChange}
                        placeholder="Area"
                      />
                    </div>
                    <div className="form-group">
                      <label>District</label>
                      <input
                        type="text"
                        name="district"
                        value={addTenantForm.district}
                        onChange={handleAddTenantChange}
                        placeholder="District"
                      />
                    </div>
                  </div>

                  <div className="form-group mb12">
                    <label>State</label>
                    <input
                      type="text"
                      name="state"
                      value={addTenantForm.state}
                      onChange={handleAddTenantChange}
                      placeholder="State"
                    />
                  </div>
                </div>

                {/* RIGHT */}
                <div>
                  <div
                    style={{
                      fontSize: 11,
                      fontWeight: 700,
                      color: "var(--text-tertiary)",
                      textTransform: "uppercase",
                      letterSpacing: ".06em",
                      marginBottom: 12,
                    }}
                  >
                    Occupation Details
                  </div>

                  <div className="form-group mb12">
                    <label>Industry / Sector</label>
                    <select
                      name="industryId"
                      value={addTenantForm.industryId}
                      onChange={handleAddTenantChange}
                    >
                      <option value="">Select industry…</option>
                      {industries.map((ind) => (
                        <option key={ind.industryId} value={ind.industryId}>
                          {ind.icon} {ind.industryName}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group mb12">
                    <label>Occupation / Role</label>
                    <select
                      name="occupationId"
                      value={addTenantForm.occupationId}
                      onChange={handleAddTenantChange}
                      disabled={!addTenantForm.industryId}
                    >
                      <option value="">Select occupation…</option>
                      {occupations.map((occ) => (
                        <option key={occ.occupationId} value={occ.occupationId}>
                          {occ.occupationName}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group mb12">
                    <label>Company / Organisation</label>
                    <input
                      type="text"
                      name="company"
                      value={addTenantForm.company}
                      onChange={handleAddTenantChange}
                      placeholder="Employer or institution name"
                    />
                  </div>

                  <div className="form-group mb12">
                    <label>Start / Move-In Date</label>
                    <input
                      type="date"
                      name="startDate"
                      value={addTenantForm.startDate}
                      onChange={handleAddTenantChange}
                    />
                  </div>

                  <div className="form-group mb12">
                    <label>End Date</label>
                    <input
                      type="date"
                      name="endDate"
                      value={addTenantForm.endDate}
                      onChange={handleAddTenantChange}
                    />
                  </div>

                  <div className="form-group mb12">
                    <label>Assign to Property</label>
                    <select
                      name="propertyId"
                      value={addTenantForm.propertyId}
                      onChange={handleAddTenantChange}
                    >
                      <option value="">Select Property…</option>
                      {isAssignPropertyData.map((assp) => (
                        <option key={assp.propertyId} value={assp.propertyId}>
                          {assp.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              <div
                style={{
                  borderTop: "0.5px solid var(--border-light)",
                  paddingTop: 16,
                  marginBottom: 14,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: 10,
                  }}
                >
                  <div>
                    <div
                      style={{
                        fontSize: 11,
                        fontWeight: 700,
                        color: "var(--text-tertiary)",
                        textTransform: "uppercase",
                        letterSpacing: ".06em",
                      }}
                    >
                      Co-Tenants / Other Members
                    </div>
                    <div
                      style={{
                        fontSize: 11,
                        color: "var(--text-secondary)",
                        marginTop: 2,
                      }}
                    >
                      People staying along with the primary tenant
                    </div>
                  </div>
                  <button
                    type="button"
                    className="btn btn-xs btn-primary"
                    onClick={() =>
                      setAddTenantForm((prev) => ({
                        ...prev,
                        coMembers: [
                          ...prev.coMembers,
                          {
                            fullName: "",
                            gender: "Male",
                            age: "",
                            relation: "",
                          },
                        ],
                      }))
                    }
                  >
                    + Add Member
                  </button>
                </div>
                {addTenantForm.coMembers.length === 0 ? (
                  <div
                    style={{
                      fontSize: 12,
                      color: "var(--text-tertiary)",
                      padding: "6px 0",
                    }}
                  >
                    No co-tenants. Click "+ Add Member" to add.
                  </div>
                ) : (
                  addTenantForm.coMembers.map((m, i) => (
                    <div
                      key={i}
                      style={{
                        display: "grid",
                        gridTemplateColumns: "2fr 1fr 1fr 1fr 28px",
                        gap: 8,
                        marginBottom: 8,
                        alignItems: "end",
                      }}
                    >
                      <div className="form-group" style={{ margin: 0 }}>
                        {i === 0 && (
                          <label style={{ fontSize: 10 }}>Full Name</label>
                        )}
                        <input
                          type="text"
                          value={m.fullName}
                          onChange={(e) =>
                            setAddTenantForm((prev) => ({
                              ...prev,
                              coMembers: prev.coMembers.map((x, idx) =>
                                idx === i
                                  ? { ...x, fullName: e.target.value }
                                  : x,
                              ),
                            }))
                          }
                          placeholder="Full name"
                          style={{ fontSize: 12, padding: "6px 8px" }}
                        />
                      </div>
                      <div className="form-group" style={{ margin: 0 }}>
                        {i === 0 && (
                          <label style={{ fontSize: 10 }}>Gender</label>
                        )}
                        <select
                          value={m.gender}
                          onChange={(e) =>
                            setAddTenantForm((prev) => ({
                              ...prev,
                              coMembers: prev.coMembers.map((x, idx) =>
                                idx === i
                                  ? { ...x, gender: e.target.value }
                                  : x,
                              ),
                            }))
                          }
                          style={{ fontSize: 12, padding: "6px 8px" }}
                        >
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                      <div className="form-group" style={{ margin: 0 }}>
                        {i === 0 && <label style={{ fontSize: 10 }}>Age</label>}
                        <input
                          type="number"
                          value={m.age}
                          onChange={(e) =>
                            setAddTenantForm((prev) => ({
                              ...prev,
                              coMembers: prev.coMembers.map((x, idx) =>
                                idx === i ? { ...x, age: e.target.value } : x,
                              ),
                            }))
                          }
                          placeholder="Age"
                          min={0}
                          style={{ fontSize: 12, padding: "6px 8px" }}
                        />
                      </div>
                      <div className="form-group" style={{ margin: 0 }}>
                        {i === 0 && (
                          <label style={{ fontSize: 10 }}>Relation</label>
                        )}
                        <input
                          type="text"
                          value={m.relation}
                          onChange={(e) =>
                            setAddTenantForm((prev) => ({
                              ...prev,
                              coMembers: prev.coMembers.map((x, idx) =>
                                idx === i
                                  ? { ...x, relation: e.target.value }
                                  : x,
                              ),
                            }))
                          }
                          placeholder="e.g. Son"
                          style={{ fontSize: 12, padding: "6px 8px" }}
                        />
                      </div>
                      <button
                        onClick={() =>
                          setAddTenantForm((prev) => ({
                            ...prev,
                            coMembers: prev.coMembers.filter(
                              (_, idx) => idx !== i,
                            ),
                          }))
                        }
                        style={{
                          width: 28,
                          height: 28,
                          border: "0.5px solid #F09595",
                          background: "var(--red-light)",
                          color: "var(--red)",
                          borderRadius: 5,
                          cursor: "pointer",
                          fontSize: 15,
                          alignSelf: "flex-end",
                        }}
                      >
                        ×
                      </button>
                    </div>
                  ))
                )}
              </div>

              <div
                style={{
                  borderTop: "0.5px solid var(--border-light)",
                  paddingTop: 16,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: 12,
                  }}
                >
                  <div>
                    <div
                      style={{
                        fontSize: 11,
                        fontWeight: 700,
                        color: "var(--text-tertiary)",
                        textTransform: "uppercase",
                        letterSpacing: ".06em",
                      }}
                    >
                      🚨 Emergency Contacts
                    </div>
                    <div
                      style={{
                        fontSize: 11,
                        color: "var(--text-secondary)",
                        marginTop: 2,
                      }}
                    >
                      People to contact in case of emergency
                    </div>
                  </div>
                  <button
                    type="button"
                    className="btn btn-xs btn-primary"
                    onClick={() =>
                      setAddTenantForm((prev) => ({
                        ...prev,
                        emergencyContacts: [
                          ...prev.emergencyContacts,
                          {
                            fullName: "",
                            relation: "",
                            mobile: "",
                            whatsApp: "",
                            address: "",
                          },
                        ],
                      }))
                    }
                  >
                    + Add Contact
                  </button>
                </div>
                {addTenantForm.emergencyContacts.length === 0 ? (
                  <div
                    style={{
                      fontSize: 12,
                      color: "var(--text-tertiary)",
                      padding: "6px 0",
                    }}
                  >
                    No emergency contacts added.
                  </div>
                ) : (
                  addTenantForm.emergencyContacts.map((c, i) => (
                    <div
                      key={i}
                      style={{
                        border: "0.5px solid var(--border-light)",
                        borderRadius: "var(--radius-md)",
                        padding: 10,
                        marginBottom: 8,
                        background: "var(--bg-secondary)",
                      }}
                    >
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "2fr 1fr 1fr 1fr",
                          gap: 8,
                          marginBottom: 8,
                        }}
                      >
                        <div className="form-group" style={{ margin: 0 }}>
                          <label style={{ fontSize: 10 }}>Full Name</label>
                          <input
                            type="text"
                            value={c.fullName}
                            onChange={(e) =>
                              setAddTenantForm((prev) => ({
                                ...prev,
                                emergencyContacts: prev.emergencyContacts.map(
                                  (x, idx) =>
                                    idx === i
                                      ? { ...x, fullName: e.target.value }
                                      : x,
                                ),
                              }))
                            }
                            placeholder="Full name"
                            style={{ fontSize: 12, padding: "6px 8px" }}
                          />
                        </div>
                        <div className="form-group" style={{ margin: 0 }}>
                          <label style={{ fontSize: 10 }}>Relation</label>
                          <input
                            type="text"
                            value={c.relation}
                            onChange={(e) =>
                              setAddTenantForm((prev) => ({
                                ...prev,
                                emergencyContacts: prev.emergencyContacts.map(
                                  (x, idx) =>
                                    idx === i
                                      ? { ...x, relation: e.target.value }
                                      : x,
                                ),
                              }))
                            }
                            placeholder="e.g. Father"
                            style={{ fontSize: 12, padding: "6px 8px" }}
                          />
                        </div>
                        <div className="form-group" style={{ margin: 0 }}>
                          <label style={{ fontSize: 10 }}>Mobile</label>
                          <input
                            type="tel"
                            value={c.mobile}
                            onChange={(e) =>
                              setAddTenantForm((prev) => ({
                                ...prev,
                                emergencyContacts: prev.emergencyContacts.map(
                                  (x, idx) =>
                                    idx === i
                                      ? { ...x, mobile: e.target.value }
                                      : x,
                                ),
                              }))
                            }
                            placeholder="Mobile"
                            style={{ fontSize: 12, padding: "6px 8px" }}
                          />
                        </div>
                        <div className="form-group" style={{ margin: 0 }}>
                          <label style={{ fontSize: 10 }}>WhatsApp</label>
                          <input
                            type="tel"
                            value={c.whatsApp}
                            onChange={(e) =>
                              setAddTenantForm((prev) => ({
                                ...prev,
                                emergencyContacts: prev.emergencyContacts.map(
                                  (x, idx) =>
                                    idx === i
                                      ? { ...x, whatsApp: e.target.value }
                                      : x,
                                ),
                              }))
                            }
                            placeholder="WhatsApp"
                            style={{ fontSize: 12, padding: "6px 8px" }}
                          />
                        </div>
                      </div>
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 28px",
                          gap: 8,
                          alignItems: "end",
                        }}
                      >
                        <div className="form-group" style={{ margin: 0 }}>
                          <label style={{ fontSize: 10 }}>Address</label>
                          <input
                            type="text"
                            value={c.address}
                            onChange={(e) =>
                              setAddTenantForm((prev) => ({
                                ...prev,
                                emergencyContacts: prev.emergencyContacts.map(
                                  (x, idx) =>
                                    idx === i
                                      ? { ...x, address: e.target.value }
                                      : x,
                                ),
                              }))
                            }
                            placeholder="Address"
                            style={{ fontSize: 12, padding: "6px 8px" }}
                          />
                        </div>
                        <button
                          onClick={() =>
                            setAddTenantForm((prev) => ({
                              ...prev,
                              emergencyContacts: prev.emergencyContacts.filter(
                                (_, idx) => idx !== i,
                              ),
                            }))
                          }
                          style={{
                            width: 28,
                            height: 28,
                            border: "0.5px solid #F09595",
                            background: "var(--red-light)",
                            color: "var(--red)",
                            borderRadius: 5,
                            cursor: "pointer",
                            fontSize: 15,
                          }}
                        >
                          ×
                        </button>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn"
                onClick={closeAddTenantModal}
                disabled={addTenantLoading}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={handleCreateTenant}
                disabled={addTenantLoading}
              >
                {addTenantLoading ? "Saving..." : "Save Tenant"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Edit Tenant Modal ── */}
      {isModalOpenEditTenant && (
        <div className="modal-overlay open">
          <div className="modal" style={{ width: 860, maxWidth: "98vw" }}>
            <div className="modal-header">
              <div className="modal-title">
                Edit Tenant — {selectedTenant?.fullName}
              </div>
              <button className="modal-close" onClick={closeEditTenantModal}>
                ✕
              </button>
            </div>
            <div className="modal-body">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                  marginBottom: 20,
                  padding: "12px 16px",
                  background: "var(--bg-secondary)",
                  borderRadius: "var(--radius-md)",
                }}
              >
                <span
                  style={{
                    fontSize: 13,
                    fontWeight: 600,
                    color: "var(--text-secondary)",
                    marginRight: 4,
                  }}
                >
                  Tenant Type:
                </span>
                {[
                  { value: "Unit", label: "Unit Tenant", icon: "🏠" },
                  { value: "Bed", label: "Bed/Seat Tenant", icon: "🛏" },
                ].map((opt) => (
                  <label
                    key={opt.value}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      padding: "8px 18px",
                      border: `1.5px solid ${editTenantForm.tenantType === opt.value ? "var(--blue)" : "var(--border-mid)"}`,
                      borderRadius: "var(--radius-md)",
                      cursor: "pointer",
                      background:
                        editTenantForm.tenantType === opt.value
                          ? "var(--blue-light)"
                          : "#fff",
                      fontWeight:
                        editTenantForm.tenantType === opt.value ? 700 : 400,
                    }}
                  >
                    <input
                      type="radio"
                      name="tenantType"
                      value={opt.value}
                      checked={editTenantForm.tenantType === opt.value}
                      onChange={handleEditTenantChange}
                      style={{ accentColor: "var(--blue)" }}
                    />
                    <span style={{ fontSize: 16 }}>{opt.icon}</span>
                    <span style={{ fontSize: 13 }}>{opt.label}</span>
                  </label>
                ))}
              </div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: 20,
                  marginBottom: 16,
                }}
              >
                {/* LEFT */}
                <div>
                  <div
                    style={{
                      fontSize: 11,
                      fontWeight: 700,
                      color: "var(--text-tertiary)",
                      textTransform: "uppercase",
                      letterSpacing: ".06em",
                      marginBottom: 12,
                    }}
                  >
                    Personal Details
                  </div>

                  <div className="form-group mb12">
                    <label>Full Name *</label>
                    <input
                      type="text"
                      name="fullName"
                      value={editTenantForm.fullName}
                      onChange={handleEditTenantChange}
                      placeholder="e.g. Priya Sharma"
                      style={
                        editTenantErrors.fullName
                          ? { borderColor: "#dc2626" }
                          : {}
                      }
                    />
                    {editTenantErrors.fullName && (
                      <span style={{ color: "#dc2626", fontSize: 11 }}>
                        {editTenantErrors.fullName}
                      </span>
                    )}
                  </div>

                  <div className="form-group mb12">
                    <label>Father's Name</label>
                    <input
                      type="text"
                      name="fatherName"
                      value={editTenantForm.fatherName}
                      onChange={handleEditTenantChange}
                      placeholder="e.g. Ramesh Sharma"
                    />
                  </div>

                  <div className="form-grid mb8">
                    <div className="form-group">
                      <label>Primary Mobile *</label>
                      <input
                        type="tel"
                        name="mobile"
                        value={editTenantForm.mobile}
                        onChange={handleEditTenantChange}
                        placeholder="10-digit number"
                        style={
                          editTenantErrors.mobile
                            ? { borderColor: "#dc2626" }
                            : {}
                        }
                      />
                      {editTenantErrors.mobile && (
                        <span style={{ color: "#dc2626", fontSize: 11 }}>
                          {editTenantErrors.mobile}
                        </span>
                      )}
                    </div>
                    <div className="form-group">
                      <label>
                        WhatsApp{" "}
                        <span
                          style={{
                            fontSize: 10,
                            color: "var(--text-tertiary)",
                            fontWeight: 400,
                          }}
                        >
                          (blank = same as mobile)
                        </span>
                      </label>
                      <input
                        type="tel"
                        name="whatsApp"
                        value={editTenantForm.whatsApp}
                        onChange={handleEditTenantChange}
                        placeholder="WhatsApp number"
                      />
                    </div>
                  </div>

                  {/* Additional Mobiles */}
                  <div style={{ marginBottom: 12 }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginBottom: 5,
                      }}
                    >
                      <label
                        style={{
                          fontSize: 12,
                          fontWeight: 600,
                          color: "var(--text-secondary)",
                        }}
                      >
                        Additional Mobiles
                      </label>
                      <button
                        type="button"
                        className="btn btn-xs"
                        onClick={() =>
                          setEditTenantForm((prev) => ({
                            ...prev,
                            additionalMobiles: [
                              ...(prev.additionalMobiles || []),
                              { mobile: "", label: "Mobile" },
                            ],
                          }))
                        }
                      >
                        + Add Number
                      </button>
                    </div>
                    {editTenantForm.additionalMobiles?.length === 0 ? (
                      <div
                        style={{ fontSize: 11, color: "var(--text-tertiary)" }}
                      >
                        None added
                      </div>
                    ) : (
                      editTenantForm.additionalMobiles?.map((m, i) => (
                        <div
                          key={i}
                          style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr 28px",
                            gap: 8,
                            marginBottom: 6,
                          }}
                        >
                          <input
                            type="tel"
                            value={m.mobile}
                            onChange={(e) =>
                              setEditTenantForm((prev) => ({
                                ...prev,
                                additionalMobiles: prev.additionalMobiles.map(
                                  (x, idx) =>
                                    idx === i
                                      ? { ...x, mobile: e.target.value }
                                      : x,
                                ),
                              }))
                            }
                            placeholder="Mobile number"
                            style={{ fontSize: 12, padding: "6px 8px" }}
                          />
                          <select
                            value={m.label}
                            onChange={(e) =>
                              setEditTenantForm((prev) => ({
                                ...prev,
                                additionalMobiles: prev.additionalMobiles.map(
                                  (x, idx) =>
                                    idx === i
                                      ? { ...x, label: e.target.value }
                                      : x,
                                ),
                              }))
                            }
                            style={{ fontSize: 12, padding: "6px 8px" }}
                          >
                            <option value="Mobile">Mobile</option>
                            <option value="WhatsApp">WhatsApp</option>
                            <option value="Work">Work</option>
                            <option value="Other">Other</option>
                          </select>
                          <button
                            onClick={() =>
                              setEditTenantForm((prev) => ({
                                ...prev,
                                additionalMobiles:
                                  prev.additionalMobiles.filter(
                                    (_, idx) => idx !== i,
                                  ),
                              }))
                            }
                            style={{
                              width: 28,
                              height: 28,
                              border: "0.5px solid #F09595",
                              background: "var(--red-light)",
                              color: "var(--red)",
                              borderRadius: 5,
                              cursor: "pointer",
                              fontSize: 15,
                            }}
                          >
                            ×
                          </button>
                        </div>
                      ))
                    )}
                  </div>

                  <div className="form-group mb12">
                    <label>Email</label>
                    <input
                      type="email"
                      name="email"
                      value={editTenantForm.email}
                      onChange={handleEditTenantChange}
                      placeholder="tenant@email.com"
                    />
                  </div>

                  <div className="form-group mb12">
                    <label>Permanent Address</label>
                    <textarea
                      name="permanentAddress"
                      value={editTenantForm.permanentAddress}
                      onChange={handleEditTenantChange}
                      style={{ minHeight: 56 }}
                      placeholder="Full permanent address"
                    />
                  </div>

                  <div className="form-group mb12">
                    <label>Pincode</label>
                    <input
                      type="text"
                      name="pincode"
                      value={editTenantForm.pincode}
                      onChange={handleEditPincodeChange}
                      maxLength={6}
                      placeholder="6-digit pincode"
                    />
                  </div>

                  <div className="form-grid mb12">
                    <div className="form-group">
                      <label>Area / Locality</label>
                      <input
                        type="text"
                        name="area"
                        value={editTenantForm.area}
                        onChange={handleEditTenantChange}
                        placeholder="Area"
                      />
                    </div>
                    <div className="form-group">
                      <label>District</label>
                      <input
                        type="text"
                        name="district"
                        value={editTenantForm.district}
                        onChange={handleEditTenantChange}
                        placeholder="District"
                      />
                    </div>
                  </div>

                  <div className="form-group mb12">
                    <label>State</label>
                    <input
                      type="text"
                      name="state"
                      value={editTenantForm.state}
                      onChange={handleEditTenantChange}
                      placeholder="State"
                    />
                  </div>
                </div>

                {/* RIGHT */}
                <div>
                  <div
                    style={{
                      fontSize: 11,
                      fontWeight: 700,
                      color: "var(--text-tertiary)",
                      textTransform: "uppercase",
                      letterSpacing: ".06em",
                      marginBottom: 12,
                    }}
                  >
                    Occupation Details
                  </div>

                  <div className="form-group mb12">
                    <label>Industry / Sector</label>
                    <select
                      name="industryId"
                      value={editTenantForm.industryId}
                      onChange={handleEditTenantChange}
                    >
                      <option value="">Select industry…</option>
                      {industries.map((ind) => (
                        <option key={ind.industryId} value={ind.industryId}>
                          {ind.icon} {ind.industryName}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group mb12">
                    <label>Occupation / Role</label>
                    <select
                      name="occupationId"
                      value={editTenantForm.occupationId}
                      onChange={handleEditTenantChange}
                      disabled={!editTenantForm.industryId}
                    >
                      <option value="">Select occupation…</option>
                      {editOccupations.map((occ) => (
                        <option key={occ.occupationId} value={occ.occupationId}>
                          {occ.occupationName}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group mb12">
                    <label>Company / Organisation</label>
                    <input
                      type="text"
                      name="company"
                      value={editTenantForm.company}
                      onChange={handleEditTenantChange}
                      placeholder="Employer or institution name"
                    />
                  </div>

                  <div className="form-group mb12">
                    <label>Start / Move-In Date</label>
                    <input
                      type="date"
                      name="startDate"
                      value={editTenantForm.startDate}
                      onChange={handleEditTenantChange}
                    />
                  </div>

                  <div className="form-group mb12">
                    <label>End Date</label>
                    <input
                      type="date"
                      name="endDate"
                      value={editTenantForm.endDate}
                      onChange={handleEditTenantChange}
                    />
                  </div>

                  {editTenantForm.tenantType === "Unit" && (
                    <div className="form-group mb12">
                      <label>Assign to Property</label>
                      <select
                        name="propertyId"
                        value={editTenantForm.propertyId}
                        onChange={handleEditTenantChange}
                      >
                        <option value="">Select Property…</option>
                        {isAssignPropertyData.map((assp) => (
                          <option key={assp.propertyId} value={assp.propertyId}>
                            {assp.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                </div>
              </div>

              {/* Co-Tenants */}
              <div
                style={{
                  borderTop: "0.5px solid var(--border-light)",
                  paddingTop: 16,
                  marginBottom: 14,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: 10,
                  }}
                >
                  <div>
                    <div
                      style={{
                        fontSize: 11,
                        fontWeight: 700,
                        color: "var(--text-tertiary)",
                        textTransform: "uppercase",
                        letterSpacing: ".06em",
                      }}
                    >
                      Co-Tenants / Other Members
                    </div>
                    <div
                      style={{
                        fontSize: 11,
                        color: "var(--text-secondary)",
                        marginTop: 2,
                      }}
                    >
                      People staying along with the primary tenant
                    </div>
                  </div>
                  <button
                    type="button"
                    className="btn btn-xs btn-primary"
                    onClick={() =>
                      setEditTenantForm((prev) => ({
                        ...prev,
                        coMembers: [
                          ...(prev.coMembers || []),
                          {
                            fullName: "",
                            gender: "Male",
                            age: "",
                            relation: "",
                          },
                        ],
                      }))
                    }
                  >
                    + Add Member
                  </button>
                </div>
                {editTenantForm.coMembers?.length === 0 ? (
                  <div
                    style={{
                      fontSize: 12,
                      color: "var(--text-tertiary)",
                      padding: "6px 0",
                    }}
                  >
                    No co-tenants. Click "+ Add Member" to add.
                  </div>
                ) : (
                  editTenantForm.coMembers?.map((m, i) => (
                    <div
                      key={i}
                      style={{
                        display: "grid",
                        gridTemplateColumns: "2fr 1fr 1fr 1fr 28px",
                        gap: 8,
                        marginBottom: 8,
                        alignItems: "end",
                      }}
                    >
                      <div className="form-group" style={{ margin: 0 }}>
                        {i === 0 && (
                          <label style={{ fontSize: 10 }}>Full Name</label>
                        )}
                        <input
                          type="text"
                          value={m.fullName}
                          onChange={(e) =>
                            setEditTenantForm((prev) => ({
                              ...prev,
                              coMembers: prev.coMembers.map((x, idx) =>
                                idx === i
                                  ? { ...x, fullName: e.target.value }
                                  : x,
                              ),
                            }))
                          }
                          placeholder="Full name"
                          style={{ fontSize: 12, padding: "6px 8px" }}
                        />
                      </div>
                      <div className="form-group" style={{ margin: 0 }}>
                        {i === 0 && (
                          <label style={{ fontSize: 10 }}>Gender</label>
                        )}
                        <select
                          value={m.gender}
                          onChange={(e) =>
                            setEditTenantForm((prev) => ({
                              ...prev,
                              coMembers: prev.coMembers.map((x, idx) =>
                                idx === i
                                  ? { ...x, gender: e.target.value }
                                  : x,
                              ),
                            }))
                          }
                          style={{ fontSize: 12, padding: "6px 8px" }}
                        >
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                      <div className="form-group" style={{ margin: 0 }}>
                        {i === 0 && <label style={{ fontSize: 10 }}>Age</label>}
                        <input
                          type="number"
                          value={m.age}
                          onChange={(e) =>
                            setEditTenantForm((prev) => ({
                              ...prev,
                              coMembers: prev.coMembers.map((x, idx) =>
                                idx === i ? { ...x, age: e.target.value } : x,
                              ),
                            }))
                          }
                          placeholder="Age"
                          min={0}
                          style={{ fontSize: 12, padding: "6px 8px" }}
                        />
                      </div>
                      <div className="form-group" style={{ margin: 0 }}>
                        {i === 0 && (
                          <label style={{ fontSize: 10 }}>Relation</label>
                        )}
                        <input
                          type="text"
                          value={m.relation}
                          onChange={(e) =>
                            setEditTenantForm((prev) => ({
                              ...prev,
                              coMembers: prev.coMembers.map((x, idx) =>
                                idx === i
                                  ? { ...x, relation: e.target.value }
                                  : x,
                              ),
                            }))
                          }
                          placeholder="e.g. Son"
                          style={{ fontSize: 12, padding: "6px 8px" }}
                        />
                      </div>
                      <button
                        onClick={() =>
                          setEditTenantForm((prev) => ({
                            ...prev,
                            coMembers: prev.coMembers.filter(
                              (_, idx) => idx !== i,
                            ),
                          }))
                        }
                        style={{
                          width: 28,
                          height: 28,
                          border: "0.5px solid #F09595",
                          background: "var(--red-light)",
                          color: "var(--red)",
                          borderRadius: 5,
                          cursor: "pointer",
                          fontSize: 15,
                          alignSelf: "flex-end",
                        }}
                      >
                        ×
                      </button>
                    </div>
                  ))
                )}
              </div>

              {/* Emergency Contacts */}
              <div
                style={{
                  borderTop: "0.5px solid var(--border-light)",
                  paddingTop: 16,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: 12,
                  }}
                >
                  <div>
                    <div
                      style={{
                        fontSize: 11,
                        fontWeight: 700,
                        color: "var(--text-tertiary)",
                        textTransform: "uppercase",
                        letterSpacing: ".06em",
                      }}
                    >
                      🚨 Emergency Contacts
                    </div>
                    <div
                      style={{
                        fontSize: 11,
                        color: "var(--text-secondary)",
                        marginTop: 2,
                      }}
                    >
                      People to contact in case of emergency
                    </div>
                  </div>
                  <button
                    type="button"
                    className="btn btn-xs btn-primary"
                    onClick={() =>
                      setEditTenantForm((prev) => ({
                        ...prev,
                        emergencyContacts: [
                          ...(prev.emergencyContacts || []),
                          {
                            fullName: "",
                            relation: "",
                            mobile: "",
                            whatsApp: "",
                            address: "",
                          },
                        ],
                      }))
                    }
                  >
                    + Add Contact
                  </button>
                </div>
                {editTenantForm.emergencyContacts?.length === 0 ? (
                  <div
                    style={{
                      fontSize: 12,
                      color: "var(--text-tertiary)",
                      padding: "6px 0",
                    }}
                  >
                    No emergency contacts added.
                  </div>
                ) : (
                  editTenantForm.emergencyContacts?.map((c, i) => (
                    <div
                      key={i}
                      style={{
                        border: "0.5px solid var(--border-light)",
                        borderRadius: "var(--radius-md)",
                        padding: 10,
                        marginBottom: 8,
                        background: "var(--bg-secondary)",
                      }}
                    >
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "2fr 1fr 1fr 1fr",
                          gap: 8,
                          marginBottom: 8,
                        }}
                      >
                        <div className="form-group" style={{ margin: 0 }}>
                          <label style={{ fontSize: 10 }}>Full Name</label>
                          <input
                            type="text"
                            value={c.fullName}
                            onChange={(e) =>
                              setEditTenantForm((prev) => ({
                                ...prev,
                                emergencyContacts: prev.emergencyContacts.map(
                                  (x, idx) =>
                                    idx === i
                                      ? { ...x, fullName: e.target.value }
                                      : x,
                                ),
                              }))
                            }
                            placeholder="Full name"
                            style={{ fontSize: 12, padding: "6px 8px" }}
                          />
                        </div>
                        <div className="form-group" style={{ margin: 0 }}>
                          <label style={{ fontSize: 10 }}>Relation</label>
                          <input
                            type="text"
                            value={c.relation}
                            onChange={(e) =>
                              setEditTenantForm((prev) => ({
                                ...prev,
                                emergencyContacts: prev.emergencyContacts.map(
                                  (x, idx) =>
                                    idx === i
                                      ? { ...x, relation: e.target.value }
                                      : x,
                                ),
                              }))
                            }
                            placeholder="e.g. Father"
                            style={{ fontSize: 12, padding: "6px 8px" }}
                          />
                        </div>
                        <div className="form-group" style={{ margin: 0 }}>
                          <label style={{ fontSize: 10 }}>Mobile</label>
                          <input
                            type="tel"
                            value={c.mobile}
                            onChange={(e) =>
                              setEditTenantForm((prev) => ({
                                ...prev,
                                emergencyContacts: prev.emergencyContacts.map(
                                  (x, idx) =>
                                    idx === i
                                      ? { ...x, mobile: e.target.value }
                                      : x,
                                ),
                              }))
                            }
                            placeholder="Mobile"
                            style={{ fontSize: 12, padding: "6px 8px" }}
                          />
                        </div>
                        <div className="form-group" style={{ margin: 0 }}>
                          <label style={{ fontSize: 10 }}>WhatsApp</label>
                          <input
                            type="tel"
                            value={c.whatsApp}
                            onChange={(e) =>
                              setEditTenantForm((prev) => ({
                                ...prev,
                                emergencyContacts: prev.emergencyContacts.map(
                                  (x, idx) =>
                                    idx === i
                                      ? { ...x, whatsApp: e.target.value }
                                      : x,
                                ),
                              }))
                            }
                            placeholder="WhatsApp"
                            style={{ fontSize: 12, padding: "6px 8px" }}
                          />
                        </div>
                      </div>
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 28px",
                          gap: 8,
                          alignItems: "end",
                        }}
                      >
                        <div className="form-group" style={{ margin: 0 }}>
                          <label style={{ fontSize: 10 }}>Address</label>
                          <input
                            type="text"
                            value={c.address}
                            onChange={(e) =>
                              setEditTenantForm((prev) => ({
                                ...prev,
                                emergencyContacts: prev.emergencyContacts.map(
                                  (x, idx) =>
                                    idx === i
                                      ? { ...x, address: e.target.value }
                                      : x,
                                ),
                              }))
                            }
                            placeholder="Address"
                            style={{ fontSize: 12, padding: "6px 8px" }}
                          />
                        </div>
                        <button
                          onClick={() =>
                            setEditTenantForm((prev) => ({
                              ...prev,
                              emergencyContacts: prev.emergencyContacts.filter(
                                (_, idx) => idx !== i,
                              ),
                            }))
                          }
                          style={{
                            width: 28,
                            height: 28,
                            border: "0.5px solid #F09595",
                            background: "var(--red-light)",
                            color: "var(--red)",
                            borderRadius: 5,
                            cursor: "pointer",
                            fontSize: 15,
                          }}
                        >
                          ×
                        </button>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn"
                onClick={closeEditTenantModal}
                disabled={editTenantLoading}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={handleUpdateTenant}
                disabled={editTenantLoading}
              >
                {editTenantLoading ? "Saving..." : "Save Changes"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Bed Assignment Modal ── */}
      {bedAssignOpen && (
        <div className="modal-overlay open">
          <div className="modal" style={{ width: 700, maxWidth: "98vw" }}>
            <div className="modal-header">
              <div>
                <div className="modal-title">
                  🛏 Assign Bed — {bedAssignTenant?.fullName}
                </div>
                <div
                  style={{
                    fontSize: 12,
                    color: "var(--text-secondary)",
                    marginTop: 2,
                  }}
                >
                  📱 {bedAssignTenant?.mobile}
                </div>
              </div>
              <button
                className="modal-close"
                onClick={() => setBedAssignOpen(false)}
              >
                ✕
              </button>
            </div>

            {bedAssignLoading ? (
              <div
                style={{
                  padding: 40,
                  textAlign: "center",
                  color: "var(--text-secondary)",
                }}
              >
                Loading...
              </div>
            ) : (
              <div className="modal-body">
                {/* Step 1 — Sharing Type */}
                <div style={{ marginBottom: 20 }}>
                  <div
                    style={{
                      fontSize: 11,
                      fontWeight: 700,
                      color: "var(--text-tertiary)",
                      textTransform: "uppercase",
                      letterSpacing: ".06em",
                      marginBottom: 10,
                    }}
                  >
                    Step 1 — Bed Type
                  </div>
                  <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                    {bedAssignData?.sharingTypes?.map((st) => (
                      <div
                        key={st.sharingTypeId}
                        onClick={() => {
                          setSelectedSharingTypeId(st.sharingTypeId);
                          setSelectedBedIds([]);
                        }}
                        style={{
                          cursor: "pointer",
                          padding: 16,
                          borderRadius: 10,
                          border: `2px solid ${selectedSharingTypeId === st.sharingTypeId ? "var(--teal)" : "var(--border-mid)"}`,
                          background:
                            selectedSharingTypeId === st.sharingTypeId
                              ? "var(--teal-light, #f0fdf4)"
                              : "#fff",
                          textAlign: "center",
                          minWidth: 100,
                          transition: "all .15s",
                        }}
                      >
                        <div style={{ fontSize: 24 }}>{st.icon}</div>
                        <div
                          style={{
                            fontWeight: 700,
                            fontSize: 13,
                            marginTop: 4,
                          }}
                        >
                          {st.name}
                        </div>
                        <div
                          style={{
                            fontSize: 10,
                            color: "#9ca3af",
                            marginTop: 2,
                          }}
                        >
                          {st.maxPersons} bed{st.maxPersons > 1 ? "s" : ""}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Step 2 — PG Property */}
                <div style={{ marginBottom: 20 }}>
                  <div
                    style={{
                      fontSize: 11,
                      fontWeight: 700,
                      color: "var(--text-tertiary)",
                      textTransform: "uppercase",
                      letterSpacing: ".06em",
                      marginBottom: 10,
                    }}
                  >
                    Step 2 — PG Property
                  </div>
                  <select
                    value={selectedPgPropertyId}
                    onChange={(e) => handlePgPropertyChange(e.target.value)}
                    style={{ width: "100%", fontSize: 13, padding: "8px 10px" }}
                  >
                    <option value="">— Select PG Property —</option>
                    {pgProperties.map((p) => (
                      <option key={p.propertyId} value={p.propertyId}>
                        {p.displayName}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Step 3 — Select Beds */}
                {selectedPgPropertyId && (
                  <div style={{ marginBottom: 14 }}>
                    <div
                      style={{
                        fontSize: 11,
                        fontWeight: 700,
                        color: "var(--text-tertiary)",
                        textTransform: "uppercase",
                        letterSpacing: ".06em",
                        marginBottom: 10,
                      }}
                    >
                      Step 3 — Select Bed{maxBedsAllowed() > 1 ? "s" : ""}{" "}
                      {selectedSharingTypeId && (
                        <span
                          style={{
                            fontWeight: 400,
                            fontSize: 10,
                            color: "var(--text-secondary)",
                          }}
                        >
                          (max {maxBedsAllowed()})
                        </span>
                      )}
                    </div>
                    {roomBedsLoading ? (
                      <div
                        style={{ fontSize: 13, color: "var(--text-secondary)" }}
                      >
                        Loading beds...
                      </div>
                    ) : roomBeds.length === 0 ? (
                      <div
                        style={{ fontSize: 13, color: "var(--text-tertiary)" }}
                      >
                        No rooms found.
                      </div>
                    ) : (
                      roomBeds.map((room) => (
                        <div key={room.pgRoomId} style={{ marginBottom: 16 }}>
                          <div
                            style={{
                              fontSize: 12,
                              fontWeight: 700,
                              color: "var(--text-secondary)",
                              marginBottom: 8,
                              display: "flex",
                              alignItems: "center",
                              gap: 6,
                            }}
                          >
                            <span
                              style={{
                                width: 4,
                                height: 16,
                                background: "var(--teal)",
                                borderRadius: 2,
                                display: "inline-block",
                              }}
                            />
                            {room.roomName}
                            <span
                              style={{
                                fontSize: 10,
                                color: "#9ca3af",
                                fontWeight: 400,
                              }}
                            >
                              Floor {room.floor}
                            </span>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: 8,
                            }}
                          >
                            {room.beds.map((bed) => {
                              const isOccupied = bed.status === "Occupied";
                              const isSelected = selectedBedIds.includes(
                                bed.bedId,
                              );
                              const isDisabled =
                                isOccupied ||
                                (!isSelected &&
                                  selectedBedIds.length >= maxBedsAllowed());
                              return (
                                <div
                                  key={bed.bedId}
                                  onClick={() =>
                                    !isDisabled &&
                                    handleBedToggle(bed.bedId, room.pgRoomId)
                                  }
                                  style={{
                                    width: 80,
                                    padding: "10px 6px",
                                    borderRadius: 10,
                                    background: isSelected
                                      ? "var(--blue-light)"
                                      : isOccupied
                                        ? "#f3f4f6"
                                        : "#fff",
                                    border: `2px solid ${isSelected ? "var(--blue)" : isOccupied ? "#d1d5db" : "var(--border-mid)"}`,
                                    cursor: isDisabled
                                      ? "not-allowed"
                                      : "pointer",
                                    textAlign: "center",
                                    transition: "all .15s",
                                    userSelect: "none",
                                    opacity:
                                      isDisabled && !isSelected ? 0.6 : 1,
                                  }}
                                >
                                  <div style={{ fontSize: 22 }}>🛏</div>
                                  <div
                                    style={{
                                      fontSize: 11,
                                      fontWeight: 700,
                                      color: isSelected
                                        ? "var(--blue)"
                                        : isOccupied
                                          ? "#9ca3af"
                                          : "var(--text-primary)",
                                      marginTop: 4,
                                    }}
                                  >
                                    Bed {bed.bedNumber}
                                  </div>
                                  <div
                                    style={{
                                      fontSize: 9,
                                      marginTop: 2,
                                      color: isOccupied ? "#9ca3af" : "#93c5fd",
                                    }}
                                  >
                                    {isOccupied ? (
                                      <>
                                        <div>{bed.occupiedBy || "—"}</div>
                                        <div>Occupied</div>
                                      </>
                                    ) : (
                                      <div>Vacant</div>
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                )}

                {selectedBedIds.length > 0 && (
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: 600,
                      color: "var(--teal)",
                      marginTop: 8,
                    }}
                  >
                    ✅ Selected: {selectedBedIds.length} bed
                    {selectedBedIds.length > 1 ? "s" : ""}
                  </div>
                )}
              </div>
            )}

            <div className="modal-footer">
              <button className="btn" onClick={() => setBedAssignOpen(false)}>
                Cancel
              </button>
              {bedAssignTenant?.bedId && (
                <button
                  className="btn"
                  style={{
                    background: "var(--red-light, #fef2f2)",
                    color: "var(--red, #dc2626)",
                    border: "1px solid var(--red, #dc2626)",
                  }}
                  onClick={handleUnassignBed}
                  disabled={unassignLoading}
                >
                  {unassignLoading ? "Unassigning..." : "🔓 Unassign"}
                </button>
              )}
              <button
                className="btn btn-primary"
                onClick={handleSaveAssignment}
                disabled={saveAssignLoading}
              >
                {saveAssignLoading ? "Saving..." : "💾 Save Assignment"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Food Plan Assignment Modal ── */}
      {foodAssignOpen && (
        <div className="modal-overlay open">
          <div className="modal" style={{ width: 480, maxWidth: "98vw" }}>
            <div className="modal-header">
              <div>
                <div className="modal-title">
                  🍽 Food Plan — {foodAssignTenant?.fullName}
                </div>
                <div
                  style={{
                    fontSize: 12,
                    color: "var(--text-secondary)",
                    marginTop: 2,
                  }}
                >
                  Select a meal plan for this tenant
                </div>
              </div>
              <button
                className="modal-close"
                onClick={() => setFoodAssignOpen(false)}
              >
                ✕
              </button>
            </div>
            <div className="modal-body">
              <div className="info-box mb12" style={{ fontSize: 11 }}>
                Click a plan to select it. The cost is added to the monthly
                bill.
              </div>
              {foodPlansLoading ? (
                Array.from({ length: 3 }).map((_, i) => (
                  <div
                    key={i}
                    style={{
                      height: 60,
                      borderRadius: 8,
                      background:
                        "linear-gradient(90deg, var(--bg-secondary) 25%, var(--border-light) 50%, var(--bg-secondary) 75%)",
                      backgroundSize: "200% 100%",
                      animation: "shimmer 1.4s infinite",
                      marginBottom: 8,
                    }}
                  />
                ))
              ) : foodPlans.length === 0 ? (
                <div
                  style={{
                    textAlign: "center",
                    color: "var(--text-tertiary)",
                    padding: 24,
                  }}
                >
                  No food plans found for this property.
                </div>
              ) : (
                foodPlans.map((plan) => (
                  <div
                    key={plan.foodPlanId}
                    onClick={() => setSelectedFoodPlanId(plan.foodPlanId)}
                    style={{
                      cursor: "pointer",
                      padding: "12px 16px",
                      borderRadius: 8,
                      border: `${selectedFoodPlanId === plan.foodPlanId ? "2px solid var(--teal)" : "1px solid var(--border-light)"}`,
                      background:
                        selectedFoodPlanId === plan.foodPlanId
                          ? "var(--teal-light, #f0fdf4)"
                          : "#fff",
                      marginBottom: 8,
                      transition: "all .15s",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        <div
                          style={{
                            fontWeight: 600,
                            fontSize: 13,
                            marginBottom: 4,
                          }}
                        >
                          {plan.label}
                        </div>
                        <div
                          style={{ display: "flex", gap: 4, flexWrap: "wrap" }}
                        >
                          {(plan.mealTypeNames || "")
                            .split(",")
                            .filter(Boolean)
                            .map((meal, i) => (
                              <span
                                key={i}
                                style={{
                                  background: "var(--teal-light, #f0fdf4)",
                                  color: "var(--teal)",
                                  borderRadius: 99,
                                  padding: "1px 7px",
                                  fontSize: 10,
                                  fontWeight: 600,
                                }}
                              >
                                {meal.trim()}
                              </span>
                            ))}
                        </div>
                      </div>
                      <div style={{ textAlign: "right" }}>
                        <div
                          style={{
                            fontWeight: 700,
                            fontSize: 14,
                            color: "var(--teal)",
                          }}
                        >
                          ₹{plan.monthlyRate?.toLocaleString("en-IN")}
                        </div>
                        <div style={{ fontSize: 10, color: "#9ca3af" }}>
                          per month
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              )}
              <div
                style={{
                  paddingTop: 10,
                  borderTop: "1px solid var(--border-light)",
                  marginTop: 6,
                }}
              >
                <button
                  onClick={() => setSelectedFoodPlanId(0)}
                  style={{
                    fontSize: 12,
                    padding: "6px 14px",
                    border: "1px solid var(--red-light)",
                    background:
                      selectedFoodPlanId === 0
                        ? "#dc2626"
                        : "var(--red-light, #fef2f2)",
                    color:
                      selectedFoodPlanId === 0 ? "#fff" : "var(--red, #dc2626)",
                    borderRadius: 6,
                    cursor: "pointer",
                  }}
                >
                  ✕ Remove Food Plan
                </button>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn" onClick={() => setFoodAssignOpen(false)}>
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={handleSaveFoodPlan}
                disabled={saveFoodLoading}
              >
                {saveFoodLoading ? "Saving..." : "💾 Save Food Plan"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
